import React from "react";
const SvgIcon = ({hash, width=24, class_='', title=''})=>(
  <svg className={`svg ${class_}`} width={width} height={width}>
      <use xlinkHref={`/media/icn5.svg#${hash}`}></use>
  </svg>
)
export default SvgIcon